import React from "react";
import Checkbox from "components/ui/Checkbox";
import cn from "classnames";
import FeatureFlag from "components/helpers/FeatureFlag"
import FlexiHelpModal from '../flexi/FlexiHelpModal';
import useModal from "hooks/useModal";

const SeasonTicketOptions = ({ setFieldValue, isFlexi, isWeekly, isMonthly, isAnnual, isCustomLength, isMobile }) => {

  const { showModal } = useModal();

  const showFlexiHelpModal = (e) => {
    e.preventDefault();

    showModal(
      <FlexiHelpModal />,
      { takeover: true }
    );
  }

  return (
    <div
      className={cn("otrl-jp__season-tickets__options",
          {
            "otrl-jp__season-tickets__options--mobile": isMobile,
          }
        )}
    >
      <div className="otrl-jp__season-tickets__journey-type">
        <FeatureFlag name="enableFlexi">
          <Checkbox
            name="isFlexi"
            label="Flexi Season"
            ariaLabel="Flexi Season"
            onChange={setFieldValue("isFlexi")}
            selected={isFlexi}
            variant="dark"
            showHelpModal={showFlexiHelpModal}
          />
        </FeatureFlag>
        <Checkbox
          name="isWeekly"
          label="Weekly"
          ariaLabel="Weekly season"
          onChange={setFieldValue("isWeekly")}
          selected={isWeekly}
          variant="dark"
        />
        <Checkbox
          name="isMonthly"
          label="Monthly"
          ariaLabel="Monthly season"
          onChange={setFieldValue("isMonthly")}
          selected={isMonthly}
          variant="dark"
        />
        <Checkbox
          name="isAnnual"
          label="Annual"
          ariaLabel="Annual season"
          onChange={setFieldValue("isAnnual")}
          selected={isAnnual}
          variant="dark"
        />
        <Checkbox
          name="isCustomLength"
          label="Custom length"
          ariaLabel="Custom season length"
          onChange={setFieldValue("isCustomLength")}
          selected={isCustomLength}
          variant="dark"
        />
      </div>
    </div>
  )
};

export default React.memo(SeasonTicketOptions);
